import { ListItemWrapper, type ListItemWrapperProps } from "common/components/lists/ListItemWrapper";
import { PublicationItem } from "domains/publication/components/PublicationItem";
import type { Source } from "entities/knowledge/types";

type PublicationListItemProps = ListItemWrapperProps & {
  title: string;
  description?: string;
  imageUrl?: string;
  source: Source;
  timestamp: number;
  isSelected?: boolean;
  link: string;
  onClick?: () => void;
};

export const PublicationListItem = ({
  title,
  description,
  imageUrl,
  source,
  timestamp,
  link,
  onClick,
  ...listItemWrapperProps
}: PublicationListItemProps) => (
  <ListItemWrapper {...listItemWrapperProps}>
    <PublicationItem
      title={title}
      description={description}
      imageUrl={imageUrl}
      source={source}
      timestamp={timestamp}
      link={link}
      onClick={onClick}
    />
  </ListItemWrapper>
);
